import { FC, useState, useRef, useEffect } from 'react'
import { Info } from 'lucide-react'
import type { CardMeta } from './types'

const isDev = process.env.NODE_ENV === 'development'

const CardInfoButton: FC<{ meta: CardMeta }> = ({ meta }) => {
  const [open, setOpen] = useState(false)
  const ref = useRef<HTMLDivElement>(null)

  useEffect(() => {
    if (!open) return
    const handleClick = (e: MouseEvent) => {
      if (ref.current && !ref.current.contains(e.target as Node)) setOpen(false)
    }
    const handleEsc = (e: KeyboardEvent) => {
      if (e.key === 'Escape') setOpen(false)
    }
    document.addEventListener('mousedown', handleClick)
    document.addEventListener('keydown', handleEsc)
    return () => {
      document.removeEventListener('mousedown', handleClick)
      document.removeEventListener('keydown', handleEsc)
    }
  }, [open])

  return (
    <div ref={ref} className='relative inline-flex'>
      <button
        onClick={(e) => { e.stopPropagation(); setOpen(!open) }}
        className='w-6 h-6 rounded-full flex items-center justify-center text-slate-500 bg-slate-50 border border-slate-200 hover:text-slate-700 hover:bg-slate-100 hover:border-slate-300 transition-all'
        title='Card info'
      >
        <Info className='w-4 h-4' />
      </button>
      {open && (
        <div className='absolute z-[1055] top-full left-1/2 -translate-x-1/2 mt-2 w-64 p-3 bg-white rounded-lg border border-slate-200 shadow-lg text-[11px] text-slate-700'>
          <p className='font-semibold text-slate-900 mb-1'>Description</p>
          <p className='mb-2'>{meta.description}</p>
          {isDev && (
            <>
              <p className='font-semibold text-slate-900 mb-1'>Endpoint</p>
              <code className='block bg-slate-50 p-1.5 rounded text-[10px] text-slate-600 break-all mb-2'>{meta.endpoint}</code>
              <p className='font-semibold text-slate-900 mb-1'>Logic</p>
              <p>{meta.logic}</p>
            </>
          )}
        </div>
      )}
    </div>
  )
}

export default CardInfoButton
